import {
  SET_KEYS,
  SET_KEYS_BLACKLISTS,
  SET_KEYS_UPDATED,
  SET_KEYS_KEYTYPES,
} from '../constants/KeyConstants';

const initialState = {
  keys: {
    list: [],
    count: 0,
  },
  blacklists: {
    list: [],
    count: 0,
  },
  keyTypes: [],
  keysUpdated: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_KEYS: {
      return {
        ...state,
        keys: {
          list: action.payload.list,
          count: action.payload.count,
        },
        keysUpdated: false,
      };
    }

    case SET_KEYS_BLACKLISTS: {
      return {
        ...state,
        blacklists: {
          list: action.payload.list,
          count: action.payload.count,
        },
      };
    }

    case SET_KEYS_KEYTYPES: {
      return {
        ...state,
        keyTypes: action.payload,
      };
    }

    case SET_KEYS_UPDATED: {
      return {
        ...state,
        keysUpdated: action.payload,
      };
    }

    default: {
      return state;
    }
  }
}
